query OrganizationShow($id: ID!) {
  organization(id: $id) {
    id
    title
    altNames
    description
    slug
    website
    status
    logo {
      id
      url
    }
    platform {
      id
      title
    }
    currency
    feeSettings {
      feeType
      percentageFee
      fixedFeeAmount {
        value
        currency
      }
      providerFeePayer
    }
    sudoUrl
    createdAt
    updatedAt
    deletedAt
    deleted
  }
}
